module.exports = __webpack_public_path__ + "logo-6836e1006f413a9751bac52ce6fdcd56.png";